module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4fWKv"))).then(() => parcelRequire('1iHdE'));